export const flagApiIdentifier = 'GjghjqKWFmb4X3QqhVg9nZ';
